/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Separator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Separator({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/OtherRelatives/Content/OtherRelative/Separator"
  
}) {
let otherRelativeItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'other_relative_item',
path: 'isLast',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={otherRelativeItemIsLastValueData ? "" : ","}
 marginRight={otherRelativeItemIsLastValueData ? "0px" : dtSpaceXxs}
 data="other_relative_item.isLast"
/>
{children}
</React.Fragment>)
}